export interface CourseBook {
  id: number;
  name: string;
}

export interface CourseDetail {
  title: string;
  subtitle: string;
  description: string;
  duration: string;
  sessions: string;
  language: string;
  books: CourseBook[];
  booksTotalValue: string;
  priceGroup: string;
  teacherNote: string;
  whatsappNumber: string;
  features: string[];
} 

export type CourseLevelKey = "A1" | "A2" | "B1" | "B2";

const teacherNote =
  "Unsere Lehrkräfte sind Muttersprachler – Lerne authentisches Deutsch von Muttersprachlern.";

const whatsappNumber = "+49 172 5467119";

const booksTotalValue = "100 €";

const commonFeatures: string[] = [
  "Deutsch lernen mit einem vollständigen interaktiven Kurs",
  "Sprechen, Hören, Lesen und Schreiben gezielt verbessern",
  "10 PDF-Lernbücher komplett kostenlos enthalten — im Wert von 100 €",
  "1 Jahr kostenloser Premium-Zugang zur Mobile App inklusive",
];

const createBooks = (level: CourseLevelKey): CourseBook[] =>
  Array.from({ length: 10 }, (_, index) => ({
    id: index + 1,
    name: `${level}.${index + 1}`,
  }));

export const courseDetailsMap: Record<CourseLevelKey, CourseDetail> = {
  A1: {
    title: "A1-DEUTSCHKURS",
    subtitle: "Gruppenkurs für Anfänger",
    description:
      "Starte noch heute deine Reise mit Deutsch. Sprich Deutsch mit Selbstvertrauen!",
    duration: "2 Monate",
    sessions: "2x pro Woche à 2 Stunden",
    language: "Deutsch & Englisch",
    books: createBooks("A1"),
    booksTotalValue,
    priceGroup: "100 €",
    teacherNote,
    whatsappNumber,
    features: commonFeatures,
  },

  A2: {
    title: "A2-DEUTSCHKURS",
    subtitle: "Gruppenkurs für Grundstufe",
    description:
      "Erweitere deinen Wortschatz und kommuniziere sicherer im Alltag.",
    duration: "2 Monate",
    sessions: "2x pro Woche à 2 Stunden",
    language: "Deutsch & Englisch",
    books: createBooks("A2"),
    booksTotalValue,
    priceGroup: "125 €",
    teacherNote,
    whatsappNumber,
    features: commonFeatures,
  },

  B1: {
    title: "B1-DEUTSCHKURS",
    subtitle: "Gruppenkurs für Mittelstufe",
    description:
      "Meistere alltägliche Situationen und diskutiere über vertraute Themen.",
    duration: "3 Monate",
    sessions: "2x pro Woche à 2 Stunden",
    language: "Deutsch & Englisch",
    books: createBooks("B1"),
    booksTotalValue,
    priceGroup: "150 €",
    teacherNote,
    whatsappNumber,
    features: commonFeatures,
  },

  B2: {
    title: "B2-DEUTSCHKURS",
    subtitle: "Gruppenkurs für Oberstufe",
    description:
      "Verstehe komplexe Texte und diskutiere fließend über abstrakte Themen.",
    duration: "3 Monate",
    sessions: "2x pro Woche à 2 Stunden",
    language: "Deutsch & Englisch",
    books: createBooks("B2"),
    booksTotalValue,
    priceGroup: "175 €",
    teacherNote,
    whatsappNumber,
    features: commonFeatures,
  },
};

export const courseLevelLabels: Record<CourseLevelKey, string> = {
  A1: "Anfänger",
  A2: "Grundstufe",
  B1: "Mittelstufe",
  B2: "Oberstufe",
};

export const courseLevelOrder: CourseLevelKey[] = ["A1", "A2", "B1", "B2"]; 